import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class ReviContentApi {
  constructor() {
    this.baseApi = ENV.BASE_API;
  }

  /**
   * Obtiene las categorías de terapia.
   * Ruta: [BASE_API]/therapy-category
   */
  async getCategories(token, active = true, idioma) {
    // Confirmado: El endpoint es /therapy-category según tu PDF y comentario
    const url = `${this.baseApi}/therapy-category?active=${active}`;

    const res = await fetch(url, {
      headers: cabecerasApi(token, idioma),
    });

    const json = await res.json();

    if (res.status !== 200) throw new Error(json.message);

    return json.therapies;
  }

  /**
   * Obtiene el listado de escenas (Salas VR).
   * Ruta: [BASE_API]/revi/content/scenes
   * * CAMBIO: limit default 1000 para traer "todas" si no hay paginación UI
   */
  async getScenes(
    token,
    { page = 1, limit = 1000, therapyId = null, search = "", idioma } = {},
  ) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (therapyId) params.append("therapyId", therapyId);
    if (search) params.append("search", search);

    const url = `${this.baseApi}/revi/content/scenes?${params.toString()}`;

    const res = await fetch(url, {
      headers: cabecerasApi(token, idioma),
    });

    const json = await res.json();

    if (res.status !== 200) throw new Error(json.message);

    return {
      scenes: json.scenes,
      pagination: json.pagination,
    };
  }
}
